 
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGenerateOTPMutation } from "./queries";
import { useClientId } from "../../../contexts/branding";
import { isHabitnuApp } from "../../../utils/white-label";
import { AlertMessage } from "../../../components/alert-message";
import { OptResponse } from "./types";

interface Props {
    onOptSuccess: ({ deliverOption, receiver }: OptResponse) => void;
    email: string;
}

export default function OTPDeliverMethod({ onOptSuccess, email }: Props) {
    const { mutateAsync, isLoading } = useGenerateOTPMutation();
    const [error, setError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const { t } = useTranslation();
    const clientId = useClientId();

    const generateOtp = async (deliverOption: "email" | "text") => {
        const {
            data: { status, message, receiver },
        } = await mutateAsync({
            deliveryMode: deliverOption,
            email,
            client_id: clientId,
        }).catch(() => ({
            data: {
                message: "Failed to generate OTP",
                status: "error",
                receiver: "",
            },
        }));

        if (status === "success") {
            setError(false);
            onOptSuccess({ deliverOption, receiver });
        } else {
            setErrorMessage(message);
            setError(true);
        }
    };

    return (
        <div>
            {error ? (
                <div className="margin-bottom-10">
                    <AlertMessage variant="danger" message={errorMessage} />
                </div>
            ) : null}
            <div className="login-otp-code">
                {t("login.receive_verification_code")}
            </div>

            <Button
                className={`w-100 btn field-height ${
                    isHabitnuApp() ? "btn-success" : "ada-btn-success"
                }`}
                onClick={() => generateOtp("email")}
                disabled={isLoading}
            >
                {t("login.code_via_email")}
            </Button>

            <div className="d-flex align-items-center btn-divider">
                <hr className="flex-grow-1" />
                <div className="divider-text">{t("login.or")}</div>
                <hr className="flex-grow-1" />
            </div>

            <Button
                variant="outline-success"
                className={`w-100 btn field-height ${
                    isHabitnuApp()
                        ? "btn-success-outlined"
                        : "ada-btn-success-outlined"
                }`}
                onClick={() => generateOtp("text")}
                disabled={isLoading}
            >
                {t("login.code_via_text")}
            </Button>
        </div>
    );
}
